import React from 'react';
import PlainCRUD, { defaultFields } from 'components/PlainCRUD';
import {
  deleteZonaDeMercado,
  getZonasDeMercados,
  patchZonaDeMercado,
  postZonaDeMercado,
} from 'api/catalogos/zonasDeMercado';
// eslint-disable-next-line react/prop-types
const ZonaDeMercado = ({ permission }) => (
  <PlainCRUD
    title="Zonas de Mercado"
    permission={permission}
    get={getZonasDeMercados}
    post={postZonaDeMercado}
    patch={patchZonaDeMercado}
    delete={deleteZonaDeMercado}
    withoutState
    fields={[defaultFields.descripcion]}
  />
);

export default ZonaDeMercado;
